import { AgentInfo } from '@interface/index';
import { ORG_CACHE_KEY, ORG_ROLE, AGENT_CACHE_KEY, AGENT_ROLE, PlanLevel } from '@config/index';
import { getAgentInfo, getOrgInfo } from '@lib/quick-func';

export enum AGENT_OPERATION {
  DELETE_AGENT,
  READ_AGENT_INFO,
  MODIFY_AGENT_INFO,
  CREATE_STRUCT_OR_LAN_AGENT,
  CREATE_LAN,
  CREATE_DATA,
  READ_DATA,
  COMMIT_TEST,
  COMMIT_REVIEW,
  REVIEW,
  MERGE,
  READ_CONNECTIONS,
  MODIFY_CONNECTIONS,
  AGENT_INTEGRATION,
  ADD_MEMBER,
  SET_MEMBER_ROLE,
  REMOVE_MEMBER,
  IMPORT,
  UPDTATE_TEMPLATE,
  DEPLOY
}

function getRoleColumnIndex(agent: AgentInfo) {

  switch (agent.role) {
    case AGENT_ROLE.ADMIN:
      return 0;
    case AGENT_ROLE.WRITE:
      return 1;
    case AGENT_ROLE.EDIT:
      return 2;
    case AGENT_ROLE.READ:
      return 3;
    default:
      return -1;
  }
}

export const EditPermission = (): boolean => {
  const org = JSON.parse(window.sessionStorage.getItem(ORG_CACHE_KEY) || '{}');
  if (org.role === ORG_ROLE.OWNER) {
    return true;
  }

  const agent = JSON.parse(window.sessionStorage.getItem(AGENT_CACHE_KEY) || '{}');
  const columnIndex = getRoleColumnIndex(agent);

  if (columnIndex < 3) {
    return true;
  }

  return false;
};

export const WritePermission = (): boolean => {
  const org = JSON.parse(window.sessionStorage.getItem(ORG_CACHE_KEY) || '{}');
  if (org.role === ORG_ROLE.OWNER) {
    return true;
  }

  const agent = JSON.parse(window.sessionStorage.getItem(AGENT_CACHE_KEY) || '{}');
  const columnIndex = getRoleColumnIndex(agent);

  if (columnIndex < 2) {
    return true;
  }

  return false;
};

export const AdminPermission = (): boolean => {
  const org = JSON.parse(window.sessionStorage.getItem(ORG_CACHE_KEY) || '{}');
  if (org.role === ORG_ROLE.OWNER) {
    return true;
  }

  const agent = JSON.parse(window.sessionStorage.getItem(AGENT_CACHE_KEY) || '{}');
  const columnIndex = getRoleColumnIndex(agent);

  if (columnIndex < 1) {
    return true;
  }

  return false;
};

export const AgentPermission = (operation: AGENT_OPERATION, forAgent?: AgentInfo, skipSupperPermission?: boolean) => {

  const org = getOrgInfo();

  if (org && org.role === ORG_ROLE.OWNER && !skipSupperPermission) {
    return true;
  }

  const agent = forAgent || JSON.parse(window.sessionStorage.getItem(AGENT_CACHE_KEY) || '{}');
  const columnIndex = getRoleColumnIndex(agent);

  if (columnIndex === -1) {
    return false;
  }

  return AGENT_PERMISSION_MAP[operation][columnIndex];
};

const AGENT_PERMISSION_MAP: { [key: number]: boolean[] } = {
  [AGENT_OPERATION.DELETE_AGENT]: [true, false, false, false],
  [AGENT_OPERATION.READ_AGENT_INFO]: [true, true, true, true],
  [AGENT_OPERATION.MODIFY_AGENT_INFO]: [true, false, false, false],
  [AGENT_OPERATION.CREATE_STRUCT_OR_LAN_AGENT]: [true, false, false, false],
  [AGENT_OPERATION.CREATE_DATA]: [true, true, false, false],
  [AGENT_OPERATION.READ_DATA]: [true, true, true, true],
  [AGENT_OPERATION.COMMIT_TEST]: [true, true, true, false],
  [AGENT_OPERATION.COMMIT_REVIEW]: [true, true, true, false],
  [AGENT_OPERATION.REVIEW]: [true, true, false, false],
  [AGENT_OPERATION.MERGE]: [true, true, false, false],
  [AGENT_OPERATION.READ_CONNECTIONS]: [true, true, true, false],
  [AGENT_OPERATION.MODIFY_CONNECTIONS]: [true, true, true, false],
  [AGENT_OPERATION.AGENT_INTEGRATION]: [true, false, false, false],
  [AGENT_OPERATION.ADD_MEMBER]: [true, false, false, false],
  [AGENT_OPERATION.SET_MEMBER_ROLE]: [true, false, false, false],
  [AGENT_OPERATION.REMOVE_MEMBER]: [true, false, false, false],
  [AGENT_OPERATION.IMPORT]: [true, true, false, false],
  [AGENT_OPERATION.UPDTATE_TEMPLATE]: [true, true, false, false],
  [AGENT_OPERATION.DEPLOY]: [true, true, false, false]
};
